import { getUiPlatform } from '../../../../environments/getUiPlatform';

export default getUiPlatform;
